import { RegistryItem } from "@schemas/agreementconditions/schema";
import { AgreementConditionType } from "__generated__/graphql";


export const LocationSchema: RegistryItem = {
	[AgreementConditionType.Location]: {
		fields: {
			"conditions.location": {
				path: "location",
				rules: {
					required: true,
				},
			},
			"conditions.locationActionType": {
				path: "locationActionType",
				rules: {
					required: true,
				},
			},
		},
		toInput: (form) => ({
			location: form.location?.id,
			locationActionType: form.locationActionType,
		}),
		toForm: (condition) => ({
			location: condition.location ?? undefined,
			locationActionType: condition.locationActionType ?? undefined,
		}),
	},
};
